import { apiMiddleware } from 'redux-api-middleware'
import { routerMiddleware } from 'connected-react-router'
import callAPI from 'utils/callAPI'
import keyMirror from 'pkeymirror'

// ------------------------------------
// Constants
// ------------------------------------
export const CHANNEL_MASTERCARDSESSION = keyMirror({
  INIT_REQUEST: null,
  INIT_SUCCESS: null,
}, 'CHANNEL_MASTERCARDSESSION')

// ------------------------------------
// Actions
// ------------------------------------
export function init() {
  return (dispatch) => {
    dispatch(callAPI({
      dispatch: dispatch,
      endpoint: 'test.json',
      requestAction: CHANNEL_MASTERCARDSESSION.INIT_REQUEST,
      successAction: CHANNEL_MASTERCARDSESSION.INIT_SUCCESS,
      success: function(result) {}
    }))
  }
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [CHANNEL_MASTERCARDSESSION.INIT_REQUEST]: (state, action) => Object.assign({}, state, action.payload),
  [CHANNEL_MASTERCARDSESSION.INIT_SUCCESS]: (state, action) => Object.assign({}, state, action.payload),
}

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {}
function reducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}

export default function(history) {
  return {
    id: 'channelMasterCardSession',
    reducerMap: {
      channelMasterCardSessionState: reducer
    },
    // middlewares when this module needed
    middlewares: [apiMiddleware, routerMiddleware(history)]
    // Actions to fire when this module is added/removed
    // initialActions: [],
    // finalActions: []
  }
}
